import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MyHttpClient } from './http-client.service';

@Injectable({
  providedIn: 'root'
})
export class LtrService {
  private server = `${environment.server}`;

  constructor(private http: MyHttpClient) {}

  getLtrForRole(profileId: string, role: string): Observable<number | null> {
    if (!profileId || !role) {
      return of(null);
    }

    const normalizedRole = role.toLowerCase();
    if (normalizedRole === 'host') {
      return this.getHostLtr(profileId);
    }
    if (normalizedRole === 'guest') {
      return this.getGuestLtr(profileId);
    }

    return of(null);
  }

  private getHostLtr(profileId: string): Observable<number | null> {
    return this.http.get(`${this.server}/api/svo/captain/hopr/metrics/${profileId}`).pipe(
      map((response: any) => {
        const metrics = response && response.data ? response.data : response;
        const netRides = metrics
          && metrics.lifeTimeRideBehaviour
          && metrics.lifeTimeRideBehaviour.netRides;
        return typeof netRides === 'number' ? netRides : null;
      }),
      catchError(() => of(null))
    );
  }

  private getGuestLtr(profileId: string): Observable<number | null> {
    return this.http.get(`${this.server}/api/customer-service/profiles/${profileId}/lifetime-rides`).pipe(
      map((response: any) => {
        const totalDroppedRides = response && response.totalDroppedRides;
        return typeof totalDroppedRides === 'number' ? totalDroppedRides : null;
      }),
      catchError(() => of(null))
    );
  }
}
